<a class="notification-link" (click)="downloadFile()">
  {{ getMessage(data.payload, localizationService) }}
</a>
